// extracted by mini-css-extract-plugin
export default {"productGallery":"VN-z","inQuickShop":"WN-z"};